import { ElevateSwapProvider } from './ElevateSwapProvider';
import type { ISwapProvider } from './ISwapProvider';
import { UniswapSwapProvider } from './UniswapSwapProvider';

type GetSwapProviderParams = {
  chainId: number;
  elevateSwapApiUrl?: string;
  jsonRpcUrl: string;
  useElevateSwapProvider?: boolean;
};

export function getSwapProvider({
  chainId,
  elevateSwapApiUrl,
  jsonRpcUrl,
  useElevateSwapProvider = false,
}: GetSwapProviderParams): ISwapProvider {
  if (useElevateSwapProvider) {
    return new ElevateSwapProvider({ swapApiUrl: elevateSwapApiUrl });
  }

  return new UniswapSwapProvider({ chainId, jsonRpcUrl });
}
